module.exports = __webpack_public_path__ + "media/country_flags/si-ccd0a1b1.png";